import { FC, Fragment } from "react";

import { EventReminderCard } from "../../rows/EventReminderCard";
import { ThankYouEmailCard } from "../../rows/ThankYouEmailCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";

type EventReminderState = { state?: string; emailDeliveryId?: string | null } | null | undefined;
type RemindersData = { reminder1?: EventReminderState; reminder2?: EventReminderState } | undefined;

interface EventRowsProps {
  showReminders: boolean;
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
  hasDate: boolean;
  hasLocation: boolean;
  remindersData: RemindersData;
  isMultiDate: boolean;
  isRemindersLoaded: boolean;
  bodyCustomConfig: { date: boolean; location: boolean; eTicket: boolean; viewTickets: boolean };
  onViewReminderResults: (params: { emailDeliveryId: string | null }) => void;
}

export const EventRows: FC<EventRowsProps> = ({
  showReminders,
  openRow,
  onToggleOpen,
  defaultValues,
  hasDate,
  hasLocation,
  remindersData,
  isMultiDate,
  isRemindersLoaded,
  bodyCustomConfig,
  onViewReminderResults,
}) => {
  const shared = { openRow, onToggleOpen };

  const rows: { key: RowKey; node: React.ReactNode }[] = [
    {
      key: "thank-you-email",
      node: (
        <ThankYouEmailCard
          {...shared}
          defaultContent={defaultValues.thankYouWinner.content}
          hasDate={hasDate}
          hasLocation={hasLocation}
        />
      ),
    },
  ];

  if (showReminders) {
    rows.push({
      key: "reminder-1",
      node: (
        <EventReminderCard
          num={1}
          {...shared}
          reminder={remindersData?.reminder1}
          isMultiDate={isMultiDate}
          isRemindersLoaded={isRemindersLoaded}
          bodyCustomConfig={bodyCustomConfig}
          defaultContent={defaultValues.reminder1.content}
          onViewResults={onViewReminderResults}
        />
      ),
    });
    rows.push({
      key: "reminder-2",
      node: (
        <EventReminderCard
          num={2}
          {...shared}
          reminder={remindersData?.reminder2}
          isMultiDate={isMultiDate}
          isRemindersLoaded={isRemindersLoaded}
          bodyCustomConfig={bodyCustomConfig}
          defaultContent={defaultValues.reminder2.content}
          onViewResults={onViewReminderResults}
        />
      ),
    });
  }

  return (
    <>
      {rows.map(({ key, node }) => (
        <Fragment key={key}>{node}</Fragment>
      ))}
    </>
  );
};
